export default __webpack_public_path__ + "static/mobile-couplethrapy-4c8d069068075ecdc83891c7012769e8.webp";